import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Container } from 'reactstrap';
import BulkImportView from './BulkImportView'

const BulkImport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Admin Settings" title="Bulk Import" mainTitle="Bulk Import" />
            <Container fluid={true}>
                <BulkImportView />
            </Container>
        </Fragment>
    )
}

export default BulkImport
